import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const ICON_SIZE = 18;

/**
 * Item de menu de primeiro nível sem submenu.
 * Renderiza diferente conforme collapsed: só ícone (com title)
 * ou ícone + label + indicador de ativo.
 */
function TopItem({ item, active, collapsed, onNavigate = undefined }) {
   const Icon = item.icon;

   if (collapsed) {
      return (
         <div className="menu-group">
            <Link
               to={item.to}
               title={item.label}
               className={`menu-link ${active ? 'active' : ''}`}
               onClick={onNavigate}
            >
               <div className="menu-icon">
                  <Icon size={ICON_SIZE} />
               </div>
            </Link>
         </div>
      );
   }

   return (
      <Link
         to={item.to}
         title={item.title}
         className={`menu-link ${active ? 'active' : ''}`}
         onClick={onNavigate}
      >
         <div className="menu-icon">
            <Icon size={ICON_SIZE} />
         </div>
         <span className="menu-label">{item.label}</span>
         {active && <div className="active-indicator" />}
      </Link>
   );
}

TopItem.propTypes = {
   item: PropTypes.shape({
      to: PropTypes.string.isRequired,
      title: PropTypes.string,
      label: PropTypes.string.isRequired,
      icon: PropTypes.elementType.isRequired,
   }).isRequired,
   active: PropTypes.bool.isRequired,
   collapsed: PropTypes.bool.isRequired,
   onNavigate: PropTypes.func,
};

export default TopItem;
